/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Praetor = zod
	.object({
		disabled: zod.boolean().describe('Whether this praetor rejects new checkout creation'),
		draft_change_count: zod
			.number()
			.describe('Number of component-level differences between live and latest'),
		environment_id: zod.uuid().describe('Environment ID'),
		has_draft: zod.boolean().describe('Whether a draft exists (latest != live)'),
		id: zod.uuid().describe('Praetor ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Insertion timestamp'),
		latest_version_id: zod.uuid().nullable().describe('Latest draft version ID'),
		live_version_id: zod.uuid().nullable().describe('Live version ID used for moderation'),
		name: zod.string().describe('Praetor name'),
		organization_id: zod.uuid().describe('Organization ID'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('A praetor configuration');

export type Praetor = zod.input<typeof Praetor>;
export type PraetorOutput = zod.output<typeof Praetor>;
